import DatePicker from "react-datepicker";
import React from "react";
import styled from "styled-components";
import { da } from "date-fns/locale";

interface StyledDatePickerProps
{
    selectedDate?: Date;
    startDate?: Date;
    endDate?: Date;
    minDate?: Date;
    selectsStart?: boolean;
    selectsEnd?: boolean;
    calendarClassName?: string;
    inline?: boolean;
    dateFormat?: string;
    customInput?: React.ReactNode;
    handleDateChange: (date: Date) => void;
    isClearable?: boolean;
}


const StyledDatePickerWrapper = styled.div`
.react-datepicker {
    border-radius: 0;
    border-color : #E4E4E4;
    font-family: var(--font-lato,'Lato',sans-serif);
}

.react-datepicker__triangle {
    border-bottom-color: #fff;
}

.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle,
.react-datepicker-popper[data-placement^="bottom"] .react-datepicker__triangle::before {
    border-bottom-color: #fff;
}

.react-datepicker__header {
    background   : none;
    border-radius: 0;
    border-bottom: 0;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
    margin: 0;
}

.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected {
    background-color: #4B4B4B;
    border-radius: 0;
}

.react-datepicker__day:focus{
    outline: none;
}

.react-datepicker__day:hover,
.react-datepicker__month-text:hover,
.react-datepicker__quarter-text:hover {
    border-radius: 0;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range {
    border-radius: 0;
}

.react-datepicker__day--selected,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-range {
    border-radius   : 0;
    background-color: #4B4B4B;
    color           : #fff;
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range,
.react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,
.react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range {
    background-color: #fff;
    color           : #000;
}

.react-datepicker__day--in-selecting-range,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__quarter-text--in-selecting-range {
    background-color: #4B4B4B;
    color           : #fff;
    border-radius   : 0;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range {
    background-color: #4B4B4B;
}

.react-datepicker__day--range-start,
.react-datepicker__day--range-end{
    background-color: #000;
}

.react-datepicker__day--selected:hover,
.react-datepicker__day--in-selecting-range:hover,
.react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover {
    background-color: #000;
    color           : #fff;
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-range {
    background-color: #fff;
    color           : #000;
}

.react-datepicker__month--selecting-range .react-datepicker__day--in-selecting-range {
    background-color: #4B4B4B;
    color           : #fff;
}

.react-datepicker__month--selecting-range .react-datepicker__day--selecting-range-start,
.react-datepicker__month--selecting-range .react-datepicker__day--selecting-range-end {
    background-color: #000;
    color           : #fff;
}
`;

const StyledDatePicker: React.FunctionComponent<StyledDatePickerProps> = (props) =>
{
    const { selectedDate, startDate, endDate, minDate, selectsStart, selectsEnd, handleDateChange, calendarClassName, inline, dateFormat, customInput, isClearable } = props;
    return (
        <StyledDatePickerWrapper>
            <DatePicker
                locale={da}
                selected={selectedDate}
                onChange={handleDateChange}
                selectsStart={selectsStart}
                selectsEnd={selectsEnd}
                startDate={startDate}
                endDate={endDate}
                minDate={minDate}
                calendarClassName={calendarClassName}
                inline={inline}
                isClearable={isClearable}
                dateFormat={dateFormat}
                customInput={customInput}
            />
        </StyledDatePickerWrapper>
    );
};

export default StyledDatePicker;